import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalUnits extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.selectFolio = this.selectFolio.bind(this);

		this.state = {
			show: false,
            id:"",
            units:[],
			cancel:false,
			delete:false,
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(units){
        if(units.length === 1){
            this.props.history.push('/transfutional_control/'+units[0].unit_id);
        }else{
            units.map((u)=>
                u.check = false
            );
            this.setState({show:true, units: units});
        }
		
	}

	handleClose(){
		this.setState({
            show: false,
            id:"",
            units:[],
            cancel:false,
            delete:false,
        });
	}


	handleSubmit(e){
		e.preventDefault();
		
        var unit_id = "";
        
        this.state.units.map((u)=>{
            if(u.check){
                unit_id = u.unit_id
            }
        });

        if(unit_id !== ""){
            this.props.history.push('/transfutional_control/'+unit_id);
        }else{
            swal('Error', 'Debe seleccionar una unidad', 'error');
        }
    }
    
    selectFolio(e, i){
        this.state.units.map((f)=>{
            f.check = false;
        });

        this.state.units[i].check = e.target.checked ? true : false;				
		
		this.forceUpdate();
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		        <Modal.Body >
                <div className="row">
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-8 col-sm-offset-2">
				        		<Table responsive hover>
				        			<thead>
										<tr>
                                            <th></th>
                                            <th>No. Unidad</th>
                                            <th>Componente</th>
                                            <th>No. Componente</th>
                                        </tr>
				        			</thead>
				        			<tbody>
										{this.state.units.map((s, i)=>{
						        			return <tr key={i}>
						        				<td>
						        					<input type="checkbox" checked={s.check}
						        						onChange={(e)=>this.selectFolio(e, i)} />
						        				</td>
						        				<td>
						        					{s.unit_number}
						        				</td>
												<td>{s.code}</td>
												<td>{s.component_number}</td>
						        			</tr>
						        		})}
					        		</tbody>
				        		</Table>
			        		</div>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer style={{textAlign:'center'}}>
		        	<FlatButton primary={true} label={'Ver'}  onClick={this.handleSubmit}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalUnits)